module.exports = __webpack_public_path__ + "img/icon_pj_dy1.7b6bd96b.png";